<template>
    <div class="form-field form-conditions">
        <div class="form-label"><label>Filtres</label></div>
        <div class="form-input">
            <div class="form-input-wrapper">

                <div v-for="(group, i) in internalValue" v-if="internalValue">
                    <div class="group">
                        <div v-for="(condition, x) in group">
                            <span class="and">and</span>
                            <div class="row">
                                <div>
                                  <select v-model="condition.type">
                                      <option v-for="option in options" v-bind:value="option.id">
                                          {{ option.name }}
                                      </option>
                                  </select>
                                </div>
                                <div style="width: 140px;"><select v-model="condition.operator">
                                    <option :value="operation.id" v-for="operation in getOperators(condition.type)">{{ operation.name }}</option>
                                </select></div>
                                <div>
                                  <form-select v-if="getOptions(condition.type) != null"
                                               multiple="true"
                                               v-model="condition.value"
                                               :default="condition.value"
                                               :options="getOptions(condition.type)"></form-select>
                                  <input v-else type="text" v-model="condition.value" :disabled="condition.operator == 'is_today' || condition.operator == 'is_null' || condition.operator == 'is_not_null'"/>
                                </div>
                                <div style="width: 60px;"><button @click="removeCondition(i, x)" class="bt-remove-condition"><span class="icon icon-icon_close"></span></button></div>

                            </div>
                        </div>
                        <button @click="addToGroup(i)" class="bt-add-condition"><span>Add new condition</span></button>
                        <button @click="renoveGroup(i)" class="bt-remove-group"><span>Remove group</span></button>
                        <span class="or">or</span>
                    </div>
                </div>
                <button @click="addGroup()" class="bt-add-group">Add new group</button>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Conditions',
        props: ['value','options','datas'],
        data: function () {
            return {
                internalValue: []
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            // CONDITIONS
            updateVars: function(){
                let tmp_conditions = [];
                for (var i=0 ; i<this.internalValue.length ; i++) {
                    var tmp_sub_conditions = [];
                    for (var x=0 ; x<this.internalValue[i].length ; x++) {
                        var obj = {};
                        obj.type = this.internalValue[i][x].type;
                        obj.operator = this.internalValue[i][x].operator;
                        obj.options = null;
                        obj.value = this.internalValue[i][x].value;
                        tmp_sub_conditions.push(obj);
                    }
                    tmp_conditions.push(tmp_sub_conditions);
                }
                this.internalValue = tmp_conditions;
                //this.resource.conditions = this.conditions;
                console.log(this.internalValue);
            },
            getOperators: function(type){
                for (var x=0 ; x<this.options.length ; x++) {
                    if( this.options[x].id == type ){
                        return this.options[x].operators;
                    }
                }
                return [];
            },
            getOptions: function(type){
              for (var x = 0 ; x < this.options.length ; x++) {
                if( this.options[x].id == type ){
                  if( this.datas && this.options[x].options && this.datas[this.options[x].options] ){
                    return this.datas[this.options[x].options];
                  }else{
                    return null;
                  }
                }
              }
              return null;
            },
            addGroup: function(){
                this.internalValue.push([]);
                this.updateVars();
            },
            addToGroup: function(index){
                this.internalValue[index].push({
                    type: "country",
                    operator: "egal",
                    options: null,
                    value: ""
                });
                this.updateVars();
            },
            renoveGroup: function(index){
                this.internalValue.splice(index,1);
                this.updateVars();
            },
            removeCondition: function(index, index2){
                this.internalValue[index].splice(index2,1);
                this.updateVars();
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                //this.updateVars()
            },
            internalValue: {
                handler: function(newVal, oldVal) {
                    this.$emit('input', this.internalValue);
                },
                deep: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Conditions.vue